import Referrer from '../referrer';
import VoucherBar from '../voucherBar';
import Container from '../container';
import logo from '../../assets/logo.svg';

import { StyledHeader, StyledLogo, StyledHeaderContainer } from './style';

const Header = () => {
  return (
    <StyledHeader>
      <StyledHeaderContainer>
        <a href="/?utm_source=coffeeandjoy-assinar&utm_medium=logo" rel="noreferrer">
          <StyledLogo src={logo} alt="coffee&amp;joy" />
        </a>
      </StyledHeaderContainer>

      <Container>
        <Referrer />
        <VoucherBar />
      </Container>
    </StyledHeader>
  )
}

export default Header;
